import React from 'react';
import PropTypes from 'prop-types';
import { default as partnerLogo } from '../../../images/Creative_community_badge.svg';
import Filter from '../../Common/Filter/Filter';
import CommunityImg from '../../Common/CommunityImg/CommunityImg';
import './CreativeCommunityHeader.scss';

const CreativeCommunityHeader = ({
  scrollToContent,
  isCreativePartnerPage = false
}) => {

  const onSelect = e => scrollToContent(e);

  return (
    <>
      <div className={`community-creative-header ${isCreativePartnerPage && 'all-creative-partner-page'}`}>
        <div className="community-creative-header-event-partner-img">
          <CommunityImg src={partnerLogo} alt="partner logo" />
        </div>
        <div className="community-creative-header-event-partner">
          <div className="community-creative-header-event-partner-title">
            Creative Community
          </div>
          <div className="community-creative-header-event-partner-subtitle">
            The noissue Creative Community is a global collective of independent designers, studios, agencies, and illustrators committed to helping bring brands to life. This community is a hub for creators to join forces, access resources, and connect with businesses looking for bespoke packaging and designs. Meet the Creatives, shop their designs, and get inspired! 
          </div>
        </div>
        {
          !isCreativePartnerPage &&
          <div className="community-creative-header-event-partner-join">
            I want to...
            <Filter
              cls='community-creative-header-event-dropdown'
              width={380}
              defaultSelection={'Find a Creative'}
              /* 'Explore Community Designs' removed during the migration to Storyblok */
              filterData={['Find a Creative', 'Join The Creative Community']}
              onSelect={onSelect}
            />
          </div>
        }
      </div>
    </>
  )
}

CreativeCommunityHeader.propTypes = {
  isAllEvents: PropTypes.bool
}

CreativeCommunityHeader.defaultProps = {
  isAllEvents: false,
}

export default CreativeCommunityHeader;